import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBackToBottomRight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21.5 18.0021H4V6.00208H20V12.2589L22 14.2589V4.00208H2V20.0021H21.5V18.0021Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M18 15.5021L21.5 19.0021L18 22.5021", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowBackToBottomRight.js.map